import PdfReportLink from './PdfReportLink';

type Props = {
    text: string;
    patientCode: string;
    patientId: string;
};

const Interpretation = ({ text, patientCode, patientId }: Props) => {
    // const { t } = useTranslation();

    return (
        <>
            {/* <SectionHeader title={t('label.interpretation')} highlight={true} />
      <p>{text}</p> */}
            <div className="report-download">
                <PdfReportLink
                    patientCode={patientCode}
                    patientId={patientId}
                />
            </div>
        </>
    );
};

export default Interpretation;
